const config = {
  vuexStorageKeys: [
    'sessionToken',
    'user'
  ],
  plugins: [
    'tk',
    'device',
    'vuexStorage',
    'user',
    'index',
    'routerAuth'
  ],
  navTheme: 'light', // 导航主题: dark 或 light
  layoutMode: 'sidemenu', // 布局类型：sidemenu 或 topmenu
  contentWidth: 'Fluid', // 内容布局类型，Fluid 或 Fixed
  fixedHeader: true, // 是否固定头部
  fixSidebar: true, // 是否固定左侧导航栏
  projectName: '古力古利',
  apiUrl: 'https://cloud.xpd.mokekeji.com/',
  appID: 'fE21zBks0hhuHFOHUjBIvSLUKpS2E1Du',
  masterKey: 'vYRqr1Tjt3ElBGPhQiSnu31lX7lGSOuE',
  modelJSON: require('./assets/json/model'),
  iconJSON: require('./assets/json/icon'),
  iconfontUrl: '//at.alicdn.com/t/font_2178061_53a2dnaifz5.js'
}
export default config
